module.exports = __webpack_public_path__ + "static/media/IMG_2345.d61602f8.jpg";